import { useMapContext } from '../MapContext'
import { useSelector } from 'react-redux'
import { selectMapMode, selectMapStatus, selectMapTheme } from '../../../store/map/map.selectors'
import { useEffect, useState } from 'react'
import { MAP_MODES, MAP_STATUS_STYLED, MAP_THEMES } from '../../../store/map/map.constants'
import { isGE, isRetina } from '../../Device'

const getRasterLayerAccordingDevice = id => new RegExp(`^${id}${isGE() ? '' : '_hd'}$`)

const useLayersManager = () => {
  const { map } = useMapContext()
  const [layersDefaultVisibility, setLayersDefaultVisibility] = useState([])
  const status = useSelector(selectMapStatus)
  const mapMode = useSelector(selectMapMode)
  const mapTheme = useSelector(selectMapTheme)

  useEffect(() => {
    if (!map || status !== MAP_STATUS_STYLED) return

    map.setLayoutProperty('simple-tiles-desktop', 'visibility', !isRetina() ? 'visible' : 'none')
    map.setLayoutProperty('simple-tiles-mobile', 'visibility', isRetina() ? 'visible' : 'none')

    const visibilities = map
      .getStyle()
      .layers.filter(layer => layer.layout && layer.layout.visibility)
      .map(({ id, layout }) => ({ id, visibility: layout.visibility }))

    setLayersDefaultVisibility(visibilities)
  }, [map, status])

  useEffect(() => {
    if (!map || layersDefaultVisibility.length === 0) return
    layersDefaultVisibility.forEach(layer => {
      let visibility = layer.visibility
      if (mapTheme === MAP_THEMES.satellite && layer.id.match(/_photo$/)) {
        visibility = 'visible'
      } else if (mapMode === MAP_MODES.tc && layer.id.match(/public_transport/)) {
        visibility = 'visible'
      } else if (mapMode === MAP_MODES.traffic && layer.id.match(/_traffic_vecto$/)) {
        visibility = 'visible'
      } else if (mapMode === MAP_MODES.bicycle && layer.id.match(getRasterLayerAccordingDevice('bicycle'))) {
        visibility = 'visible'
      } else if (mapTheme === MAP_THEMES.satellite) {
        visibility = 'none'
      }
      map.setLayoutProperty(layer.id, 'visibility', visibility)
    })
  }, [map, layersDefaultVisibility, mapMode, mapTheme])
}

export default useLayersManager
